import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { type CopyConfig } from 'antd/es/typography/Base';
import { type TextProps } from 'antd/es/typography/Text';

const { Text } = Typography;

const CopyIcons = [
  <CopyOutlined key="copy-icon" aria-hidden />,
  <CheckOutlined key="copied-icon" aria-hidden />,
];

export interface ICopyableTextProps extends TextProps {}

/**
 * Componente che mostra un testo copiabile con le icone corrette per A11Y
 */
export function CopyableText(props: ICopyableTextProps) {
  const { copyable, ...textProps } = props;

  const copyOptions: CopyConfig =
    typeof copyable === 'object'
      ? { ...copyable, icon: CopyIcons }
      : { icon: CopyIcons };

  return <Text copyable={copyOptions} {...textProps} />;
}
